import { debounce } from 'throttle-debounce';
import saveTemplate from "fantastic/actions/saveTemplate";

const dispatchNecessitySaving = (dispatch) => dispatch({ type: 'NECESSITY_SAVING' });
const debouncedSaveTemplate = debounce(2000, saveTemplate);

export default (dispatch, getState) => {
  dispatchNecessitySaving(dispatch);
  debouncedSaveTemplate(dispatch, getState)
};
